module.exports = __webpack_public_path__ + "static/media/5.f57dc197.png";